import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Box,
  Stepper,
  Button,
  Group,
  Text,
  Tabs,
  SimpleGrid,
} from "@mantine/core";
import { useSelector } from "react-redux";
import { useServicePlanStyles } from "./style";
import ClientDataStep from "./ServicePlanSteps/ClientDataStep";
import AssessmentStep from "./ServicePlanSteps/AssessmentStep";
import ActivitiesOfDailyLivingStep from "./ServicePlanSteps/ActivitiesOfDailyLivingStep";
import CareAndSafetyStep from "./ServicePlanSteps/CareAndSafetyStep";
import SignatureStep from "./ServicePlanSteps/SignatureStep";
import { v4 as uuidv4 } from "uuid";
import { addPlan, editPlan } from "../../services/supportplan";
import jsPDF from "jspdf";
import { uploadFileToS3Api } from "../../utils/PresignedUrlFunction";
import { getServicePlanBlob } from "../ServicePlanPreview";
import { ADL_TASK_TRIGGER_ID } from "../../pages/Home/Task/AddTask";
import { getClientTask } from "../../services/task";

const ServicePlanForm = ({
  view,
  edit,
  rowData,
  onSave,
  onClose,
  client,
  selectedFacility,
  addPlanLoading,
  headerInputSection,
  period,
  planTypeId,
  closeCarePlanModal,
  errors,
  setErrors,
  initialOutcome,
  initialEssentialSupport,
  initialGoals,
}) => {
  console.log("🚀 ~ ServicePlanForm ~ rowData:", rowData);
  const containerRef = useRef(null);
  const { classes } = useServicePlanStyles();
  const [active, setActive] = useState(0);
  const [planId, setPlanId] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [uploadedPdf, setUploadedPdf] = useState(null);
  const { profile } = useSelector((state) => state?.profile);
  const [taskTypeDetails, setTypeDetails] = useState(null);
  const [checks, setChecks] = useState([]);
  console.log("🚀 ~ ServicePlanForm ~ checks:", checks);
  const { allFacilities } = useSelector((state) => state?.facility);

  const [formData, setFormData] = useState({
    // Client Data (Step 1)
    clientData: {
      firstName: client?.form1?.firstName || "",
      lastName: client?.form1?.lastName || "",
      // service: "",
      // facility: selectedFacility || "",
      // effectivePeriod: { start: null, end: null },
      admissionDate: client?.form1?.admissionDate || null,
      // assessmentType: "",
      dateOfBirth: client?.form1?.dob || null,
      // codeStatus: "",
      levelOfCare: client?.form1?.levelofcare || null,
      // dateOfLastTBScreening: null,
      weightLbs: client?.form1?.weight || "",
      // bloodPressure: "",
      // pulse: "",
      // oxygen: "",
      // respiration: "",
      // temperature: "",
      // glucoseCheck: "",
      // frequency: "",
      diagnosis: client?.form1?.diagnosis || [],
      allergies: client?.form1?.knownAllergies || [],
      // otherHistory: "",
      primaryCarePhysician:
        client?.form2?.pcpFirstName + " " + client?.form2?.pcpLastName || "",
      pcpPhone: client?.form2?.pcpPhoneNumber || "",
      pharmacyName: client?.form2?.pharmacyName || "",
      pharmacyPhone: client?.form2?.pharmacyPhoneNumber || "",
    },

    assessment: {
      // nutrition: [],
      // mealsLocation: [],
      // feedingAssistance: [],
      // hydration: [],
      // assistiveDevices: [],
      // vision: [],
      // speech: [],
      // hearing: [],
    },

    // Activities of Daily Living (Step 3)
    activitiesOfDailyLiving: {
      fieldsDone:
        rowData?.servicePlanData?.activitiesOfDailyLiving?.fieldsDone || [],
      // brushingTeeth: [],
      // bedCheck: [],
      // skinCare: [],
      // nutritionAndHydration: [],
      // toileting: [],
      // undergarments: [],
      // dressing: [],
      // grooming: [],
      // vitalSignsAndHealthMonitoring: [],
      // shower: [],
      // other: [],
    },

    // Care and Safety (Step 4)
    careAndSafety: {
      // safetyMonitoring: [],
      // cognitiveActivities: [],
      // coordinationOfCare: [],
      // familyRepCommunication: [],
      // medicationAdministration: [],
      // cognitiveStatus: [],
      // mobilityAmbulationTransfer: [],
      // nursingMedicalInstructions: [],
      // conditionsRequiringCaregivers: [],
    },

    // Signature (Step 5)
    signature: [
      // {
      //   id: profile?.user?.id,
      //   fullName: profile?.user?.name || "",
      //   title: "Admin",
      //   date: new Date(),
      //   userType: "admin",
      // },
      // {
      //   id: uuidv4(),
      //   fullName: "",
      //   title: "",
      //   date: new Date(),
      //   signatureRequestStatus: "pending",
      //   position: "Client/POA Signature",
      // },
      {
        id: uuidv4(),
        fullName: "",
        title: "",
        date: new Date(),
        signatureRequestStatus: "pending",
        position: "Facility",
      },
      // {
      //   id: uuidv4(),
      //   fullName: "",
      //   title: "",
      //   date: new Date(),
      //   signatureRequestStatus: "pending",
      //   position: "Medical Professional",
      // },
      // {
      //   id: uuidv4(),
      //   fullName: "",
      //   title: "",
      //   date: new Date(),
      //   signatureRequestStatus: "pending",
      //   position: "Other",
      // },
    ],
  });
  console.log("🚀 ~ ServicePlanForm ~ formData:", formData);

  useEffect(() => {
    if (edit || view) {
      loadExistingData();
    }
  }, [edit, view, rowData]);

  useEffect(() => {
    if (active === 4 && !uploadedPdf) {
      const generateOnEnter = async () => {
        let payload = {
          planType: planTypeId,
          facility: selectedFacility,
          client: client?.id,
          isActive: true,
          startDate: period.startDate,
          endDate: period.endDate,
          servicePlanData: formData,
        };
        const result = await downloadPlanPDF(payload);
        setUploadedPdf(result);
      };
      generateOnEnter();
    }
  }, [active, view, uploadedPdf]);
  useEffect(() => {
    if (active === 4 && !uploadedPdf) {
      generateAndUploadPDF();
    }
  }, [active]);

  useEffect(() => {
    if (!client?.id) return;

    const fetchTasks = async () => {
      try {
        const data = await getClientTask({
          client: client.id,
          type: ADL_TASK_TRIGGER_ID,
          // type: "6989b426b0db571633269e6a",
        });

        setTypeDetails(data?.taskType);
        // ✅ Initialize checks with fieldsDone from all subtasks
        // if (data?.taskType?.subTasks) {
        //   const allFieldsDone = data.taskType.subTasks.flatMap(
        //     task => task.fieldsDone || []
        //   );
        //   console.log("🚀 ~ fetchTasks ~ allFieldsDone:", allFieldsDone)

        //   // Only set if checks is empty (to avoid overwriting user changes)
        //   if (checks.length === 0 && allFieldsDone.length > 0) {
        //     setChecks(allFieldsDone);
        //   }
        // }
      } catch (error) {
        console.error("❌ Error fetching client task:", error);
      }
    };

    fetchTasks();
  }, [client?.id]);

  const loadExistingData = () => {
    if (rowData?.servicePlanData) {
      setPlanId(rowData?._id);
      setFormData(rowData?.servicePlanData);
      // Initialize checks from existing service plan data so UI stays in sync
      setChecks(
        rowData?.servicePlanData?.activitiesOfDailyLiving?.fieldsDone || [],
      );
      if (rowData?.fileUrl) {
        setUploadedPdf({ fileUrl: rowData.fileUrl });
      }
    }
  };

  // Keep formData.activitiesOfDailyLiving.fieldsDone synced with checks
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      activitiesOfDailyLiving: {
        ...(prev.activitiesOfDailyLiving || {}),
        fieldsDone: checks || [],
      },
    }));
  }, [checks]);

  const handleStepData = (stepName, data) => {
    setFormData((prev) => ({
      ...prev,
      [stepName]: data,
    }));
  };

  const validateStep = (stepIndex) => {
    const stepErrors = {};

    switch (stepIndex) {
      case 0: // Client Data
        if (!period.startDate || !period.endDate) {
          stepErrors.endDate = "Required.";
        }
        break;

      case 1: // Assessment
        // Add validation for assessment step if needed
        break;

      case 2: // Activities of Daily Living
        // Add validation if needed
        break;

      case 3: // Care and Safety
        // Add validation if needed
        break;

      case 4: // Signature
        // if (!view && !formData.signature.residentSignature) {
        //   stepErrors.residentSignature = "Resident signature is required";
        // }
        break;

      default:
        break;
    }

    setErrors(stepErrors);
    return Object.keys(stepErrors).length === 0;
  };

  const generateAndUploadPDF = async () => {
    try {
      const currentPayload = {
        id: planId,
        planType: planTypeId,
        facility: selectedFacility,
        client: client?.id,
        startDate: period?.startDate,
        endDate: period?.endDate,
        servicePlanData: formData,
      };

      // getServicePlanBlob uses @react-pdf/renderer under the hood
      const blob = await getServicePlanBlob({
        planPayload: currentPayload,
        taskTypeDetails,
      });
      const file = new File([blob], `service_plan_${Date.now()}.pdf`, {
        type: "application/pdf",
      });
      const result = await uploadFileToS3Api({ file });
      setUploadedPdf({
        fileUrl: result?.uploadURL,
        name: file.name,
        size: file.size,
        type: file.type,
      });
    } catch (err) {
      console.error("PDF generation/upload failed:", err);
    }
  };
  const nextStep = async () => {
    try {
      setBtnLoading(true);
      if (validateStep(active)) {
        // && !planId
        if (active === 0 && !planId) {
          let payload = {
            planType: planTypeId,
            facility: selectedFacility,
            client: client?.id,
            isActive: false,
            startDate: new Date(),
            endDate: period.endDate,
            outcomes: [{ id: Date.now(), ...initialOutcome, outcomeNumber: 1 }],
            essentialSupport: [
              {
                id: Date.now(),
                ...initialEssentialSupport,
                essentialNumber: 1,
              },
            ],
            goals: [{ id: Date.now(), ...initialGoals, goalNumber: 1 }],
            servicePlanData: formData,
            status: "draft",
          };
          const response = await addPlan(payload);
          if (response?.status === 200) {
            setPlanId(response?.data?.plan?.id);
            const pdfResult = await downloadPlanPDF(payload);
            setUploadedPdf(pdfResult);
            setActive((current) => current + 1);
          }
        } else if (active === 1) {
          let payload = {
            id: planId,
            planType: planTypeId,
            facility: selectedFacility,
            client: client?.id,
            startDate: period.startDate,
            endDate: period.endDate,
            outcomes: [{ id: Date.now(), ...initialOutcome, outcomeNumber: 1 }],
            essentialSupport: [
              {
                id: Date.now(),
                ...initialEssentialSupport,
                essentialNumber: 1,
              },
            ],
            goals: [{ id: Date.now(), ...initialGoals, goalNumber: 1 }],
            servicePlanData: formData,
            isActive: false,
            status: "draft",
          };
          const response = await editPlan(payload);
          if (response) {
            const pdfResult = await downloadPlanPDF(payload);
            setUploadedPdf(pdfResult);
            setActive((current) => (current < 4 ? current + 1 : current));
          }
        } else if (active === 2) {
          let payload = {
            id: planId,
            planType: planTypeId,
            facility: selectedFacility,
            client: client?.id,
            startDate: period.startDate,
            endDate: period.endDate,
            outcomes: [{ id: Date.now(), ...initialOutcome, outcomeNumber: 1 }],
            essentialSupport: [
              {
                id: Date.now(),
                ...initialEssentialSupport,
                essentialNumber: 1,
              },
            ],
            goals: [{ id: Date.now(), ...initialGoals, goalNumber: 1 }],
            servicePlanData: formData,
            isActive: false,
            status: "draft",
          };
          const response = await editPlan(payload);
          if (response) {
            const pdfResult = await downloadPlanPDF(payload);
            setUploadedPdf(pdfResult);
            setActive((current) => (current < 4 ? current + 1 : current));
          }
        } else if (active === 3) {
          let payload = {
            id: planId,
            planType: planTypeId,
            facility: selectedFacility,
            client: client?.id,
            startDate: period.startDate,
            endDate: period.endDate,
            outcomes: [{ id: Date.now(), ...initialOutcome, outcomeNumber: 1 }],
            essentialSupport: [
              {
                id: Date.now(),
                ...initialEssentialSupport,
                essentialNumber: 1,
              },
            ],
            goals: [{ id: Date.now(), ...initialGoals, goalNumber: 1 }],
            servicePlanData: formData,
            isActive: true,
            status: "active",
          };
          const response = await editPlan(payload);
          if (response) {
            const pdfResult = await downloadPlanPDF(payload);
            setUploadedPdf(pdfResult);
            setActive((current) => (current < 4 ? current + 1 : current));
          }
        } else {
          setActive((current) => (current < 4 ? current + 1 : current));
        }
      }
    } catch (error) {
    } finally {
      setBtnLoading(false);
    }
  };

  const checkPage = (doc, y) => {
    if (y > 270) {
      doc.addPage();
      return 20;
    }
    return y;
  };

  const downloadPlanPDF = async (payload) => {
    try {
      // ✅ Same renderer jo ServicePlanPDFPreview use karta hai
      const blob = await getServicePlanBlob({
        planPayload: payload,
        taskTypeDetails,
      });
      const file = new File([blob], `service_plan_${Date.now()}.pdf`, {
        type: "application/pdf",
      });
      const result = await uploadFileToS3Api({ file });
      return {
        fileUrl: result?.uploadURL,
        name: file.name,
        size: file.size,
        type: file.type,
      };
    } catch (error) {
      console.error("PDF Upload failed:", error);
      return null;
    }
  };

  const prevStep = () => {
    setActive((current) => (current > 0 ? current - 1 : current));
  };

  const handleSave = async () => {
    // if (validateStep(active)) {
    // console.log("🚀 ~ handleSave ~ payload:", formData);
    // await onSave(formData);
    // }

    try {
      setBtnLoading(true);
      let payload = {
        id: planId,
        planType: planTypeId,
        facility: selectedFacility,
        client: client?.id,
        startDate: period.startDate,
        endDate: period.endDate,
        outcomes: [{ id: Date.now(), ...initialOutcome, outcomeNumber: 1 }],
        essentialSupport: [
          {
            id: Date.now(),
            ...initialEssentialSupport,
            essentialNumber: 1,
          },
        ],
        goals: [{ id: Date.now(), ...initialGoals, goalNumber: 1 }],
        servicePlanData: formData,
        status: "active",
      };
      const response = await editPlan(payload);
      closeCarePlanModal();
    } catch (error) {
    } finally {
      setBtnLoading(false);
    }
  };

  useEffect(() => {
    if (!containerRef.current) return;

    // Walk up the DOM to find the scrollable parent
    const getScrollableParent = (el) => {
      while (el && el !== document.body) {
        const { overflow, overflowY } = window.getComputedStyle(el);
        if (/(auto|scroll)/.test(overflow + overflowY)) return el;
        el = el.parentElement;
      }
      return window;
    };

    const scrollableParent = getScrollableParent(containerRef.current);
    scrollableParent.scrollTo({ top: 0, behavior: "smooth" });
  }, [active]);

  const getPlanPayload = useCallback(
    () => ({
      id: planId,
      planType: planTypeId,
      facility: selectedFacility,
      client: client?.id,
      startDate: period.startDate,
      endDate: period.endDate,
      outcomes: [{ id: Date.now(), ...initialOutcome, outcomeNumber: 1 }],
      essentialSupport: [
        {
          id: Date.now(),
          ...initialEssentialSupport,
          essentialNumber: 1,
        },
      ],
      goals: [{ id: Date.now(), ...initialGoals, goalNumber: 1 }],
      servicePlanData: formData,
    }),
    [planId, planTypeId, selectedFacility, client?.id, period, formData],
  );

  const getPlanPayloadForPdf = useCallback(
    () => ({
      id: planId,
      planType: planTypeId,
      facility: allFacilities?.facilities?.find((f) => f.id === selectedFacility)?.name || "",
      client: client?.id,
      startDate: period.startDate,
      endDate: period.endDate,
      servicePlanData: formData,
    }),
    [planId, planTypeId, selectedFacility, client?.id, period, formData],
  );

  const steps = [
    {
      label: "Client Data",
      component: (
        <ClientDataStep
          data={formData.clientData}
          onChange={(data) => handleStepData("clientData", data)}
          view={view}
          errors={errors}
          selectedFacility={selectedFacility}
        />
      ),
    },
    {
      label: "Assessment",
      component: (
        <AssessmentStep
          data={formData?.assessment}
          onChange={(data) => handleStepData("assessment", data)}
          view={view}
          errors={errors}
        />
      ),
    },
    {
      label: "Activities of Daily Living",
      component: (
        <ActivitiesOfDailyLivingStep
          data={formData.activitiesOfDailyLiving}
          onChange={(data) => handleStepData("activitiesOfDailyLiving", data)}
          view={view}
          errors={errors}
          client={client}
          checks={checks}
          setChecks={setChecks}
          taskTypeDetails={taskTypeDetails}
        />
      ),
    },
    {
      label: "Care and Safety",
      component: (
        <CareAndSafetyStep
          data={formData.careAndSafety}
          onChange={(data) => handleStepData("careAndSafety", data)}
          view={view}
          errors={errors}
        />
      ),
    },
    {
      label: "Signature",
      component: (
        <SignatureStep
          data={formData.signature}
          onChange={(data) => handleStepData("signature", data)}
          view={view}
          edit={edit}
          errors={errors}
          activeStep={active}
          getPlanPayload={getPlanPayload}
          getPlanPayloadForPdf={getPlanPayloadForPdf}
          uploadedFiles={uploadedPdf}
          taskTypeDetails={taskTypeDetails}
        />
      ),
    },
  ];

  return (
    <Box ref={containerRef} className={classes.servicePlanContainer}>
      <Tabs
        value={active.toString()}
        onTabChange={(value) => setActive(Number(value))}
        styles={{
          tab: {
            "&[data-active]": {
              borderColor: "rgba(0, 0, 0, 1)",
              color: "rgba(0, 0, 0, 1)",
            },
            "&:hover": {
              borderColor: "rgba(0, 0, 0, 1)",
              color: "rgba(0, 0, 0, 1)",
            },
          },
          tabsList: {
            borderBottom: "none",
            backgroundColor: "white",
          },
        }}
      >
        {selectedFacility && (
          <Tabs.List mb="md" grow>
            {steps.map((step, index) => (
              <Tabs.Tab
                value={index.toString()}
                key={index}
                disabled={!view && !edit}
              >
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <Text size="sm" color="dimmed">
                    {index + 1}
                  </Text>
                  <Text fw={500}>{step.label}</Text>
                </Box>
              </Tabs.Tab>
            ))}
          </Tabs.List>
        )}

        {headerInputSection}

        {selectedFacility &&
          steps.map((step, index) => (
            <Tabs.Panel value={index.toString()} key={index}>
              <Box className={classes.stepContent}>{step.component}</Box>
            </Tabs.Panel>
          ))}
      </Tabs>

      {selectedFacility && (
        <SimpleGrid
          cols={active > 0 ? 2 : 1}
          mt="xl"
          className={classes.navigationButtons}
        >
          {active > 0 && (
            <Button
              variant="outline"
              onClick={prevStep}
              disabled={view}
              size="lg"
              color="gray"
              c={"#000"}
              fullWidth
            >
              Back
            </Button>
          )}
          {active < steps.length - 1 ? (
            <Button
              fullWidth
              onClick={nextStep}
              color="yellow"
              loading={btnLoading}
              disabled={view}
              c={"#000"}
              size="lg"
            >
              Save and Continue
            </Button>
          ) : (
            <Button
              c={"#000"}
              fullWidth
              onClick={handleSave}
              loading={btnLoading}
              size="lg"
              disabled={view}
              color="yellow"
            >
              {edit ? "Update" : "Save"}
            </Button>
          )}
        </SimpleGrid>
      )}
    </Box>
  );
};

export default ServicePlanForm;
